import React from "react";
import { Edit } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { CompanyForm } from "./CompanyForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

interface ICompanyCreateProps {}

export const CompanyEdit = (props: ICompanyCreateProps) => {
  const notify = useNotification(props, "editSuccess");
  const fieldPermissions = useFieldPermissions(
    protectedEntities.Company,
    (x) => x.edit
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Edit
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        title="resources.admin-companies.title.edit">
        <CompanyForm />
      </Edit>
    </FieldPermissionsContext.Provider>
  );
};
